import React from 'react';
import ApiClient from '../../../ApiClient';
import PricingModelEditor from './PricingModelEditor';
import PricingModelsList from './PricingModelsList';
// The base no-unused-vars rule does not see type-only uses.
// eslint-disable-next-line no-unused-vars
import * as pricingModels from './pricingModels';

export const PricingModelsListView = ({
  navigate,
}: {
  navigate: (path: string) => void;
}): JSX.Element => <PricingModelsList apiClient={ApiClient} navigate={navigate} />;

type Navigate = (path: string, state: pricingModels.SubmittedState) => void;

export const PricingModelCreateView = ({ navigate }: { navigate: Navigate }): JSX.Element => (
  <PricingModelEditor apiClient={ApiClient} navigate={navigate} />
);

// Keyed on the id so moving between pricing models starts from a fresh form.
export const PricingModelEditView = ({
  navigate,
  priceSchemeId,
  submittedChangeSetId,
}: {
  navigate: Navigate;
  priceSchemeId: string;
  submittedChangeSetId?: string;
}): JSX.Element => (
  <PricingModelEditor
    key={priceSchemeId}
    apiClient={ApiClient}
    navigate={navigate}
    priceSchemeId={priceSchemeId}
    submittedChangeSetId={submittedChangeSetId}
  />
);
